import { createContext, useContext, useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("shingare_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => {
        setUser(r.data);
        localStorage.setItem("shingare_user", JSON.stringify(r.data));
      })
      .catch(() => {
        localStorage.removeItem("shingare_token");
      })
      .finally(() => setLoading(false));
  }, []);

  async function login(email, password) {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("shingare_token", data.token);
      localStorage.setItem("shingare_user", JSON.stringify(data.user));
      setUser(data.user);
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: apiErr(e) };
    }
  }

  function logout() {
    localStorage.removeItem("shingare_token");
    localStorage.removeItem("shingare_user");
    setUser(null);
  }

  async function changePassword(current_password, new_password) {
    try {
      await api.post("/auth/change-password", { current_password, new_password });
      const updated = { ...user, must_change_password: false };
      setUser(updated);
      localStorage.setItem("shingare_user", JSON.stringify(updated));
      return { ok: true };
    } catch (e) {
      return { ok: false, error: apiErr(e) };
    }
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, changePassword, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
